var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDeviceMobile = function SvgIconDeviceMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.5 3.25a.5.5 0 0 0-.5.5V5h10V3.75a.5.5 0 0 0-.5-.5zm-2.5.5v16.5a2.5 2.5 0 0 0 2.5 2.5h9a2.5 2.5 0 0 0 2.5-2.5V3.75a2.5 2.5 0 0 0-2.5-2.5h-9A2.5 2.5 0 0 0 5 3.75M17 17V7H7v10zM7 19h10v1.25a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconDeviceMobile;